/**
 * User certificate API – all endpoints used by certificate pages.
 * Base path: /org/usercertificate (user certificate routes mounted in backend userRoutes).
 */
import { GET, POST } from '../apiController';

const ORG_USER_CERTIFICATE = '/user/usercertificate';

export const getTraineeCertificates = () => {
  return GET(`${ORG_USER_CERTIFICATE}/get_certificates`);
};

export const checkCertificateEligibility = () => {
  return GET(`${ORG_USER_CERTIFICATE}/check_eligibility`);
};

export const generateCertificate = (data = {}) => {
  return POST(`${ORG_USER_CERTIFICATE}/generate_certificate`, data);
};
